import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    DateInput,
    ShowButton
} from 'react-admin';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Filter from './Filter';
import Actions from './Actions'

const CustomShowBtn = props => {
    return (<ShowButton label={props.record.id} {...props}/>)
}

const ContractList = (props) => (
    <List {...props}
          filters={<Filter/>}
          bulkActionButtons={false}
          currentSort={{ field: 'dispensedAt', order: 'DESC' }}
          perPage={25}
          title="Погашення рецептів"
          actions={<Actions/>}
          className="list-styles"
          empty={false}
    >
        <Datagrid>
            <CustomShowBtn style={{whiteSpace: 'nowrap'}} />
            <TextField style={{whiteSpace: 'nowrap'}} label="Рецепт" source="medicationRequest.requestNumber" sortable={false}/>
            <TextField label="Препарат" source="medicationRequest.medicationInfo.medicationName" sortable={false}/>
            <DateField style={{whiteSpace: 'nowrap'}} label="Дата погашення" source="dispensedAt" sortable={false} options={{ year: 'numeric', month: 'long', day: 'numeric' }}  locales="uk-UA" />
            <TextField label="Ким погашено" source="dispensedBy" sortable={false} />
        </Datagrid>
    </List>
);

export default ContractList;
